import { isNil } from 'lodash';
import { MissingParamError } from '../../../errors';
import { Fetch } from '../../shared/types';
import { EditAccessResponse, Zap } from '../../zapier/types';

type Options = {
  cuid: Zap['cuid'];
};

export const getEditAccess = async (
  fetch: Fetch,
  { cuid }: Options
): Promise<EditAccessResponse> => {
  if (isNil(cuid)) {
    throw new MissingParamError('CUID is required.');
  }

  return fetch<EditAccessResponse>(`/api/access/v1/check-assets`, {
    params: {
      assets: `zap:${cuid}`,
      permissions_checks: 'can_edit',
    },
  });
};

export default getEditAccess;
